import { IErrorField } from './validate';

export const getErrorForField = (field: string, errors: IErrorField[]) =>
    errors.find((err) => err.field === field)?.message || '';
